import {
  CloudArrowUpIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";
import Trust from "../assets/images/trust.jpeg";

const features = [
  {
    name: "Хяналт.",
    description:
      "МУ-ын ЦБД-д зааснаар нүдэнд харагдахуйцаар таслалт хийдэг зориулалт бүхий орчин үеийн модуль самбар.",
    icon: CloudArrowUpIcon,
  },
  {
    name: "Гал тусгаарлалт.",
    description: "Гал дэмждэггүй тусгаарлагч материалаар хийгдсэн.",
    icon: LockClosedIcon,
  },
  {
    name: "Цахилгаан тусгаарлалт.",
    description:
      "Хүн цахилгаанд цохиулах болон богино залгааны үед гарч болзошгүй аюулаас найдвартай хамгаалагдсан.",
    icon: ServerIcon,
  },
  {
    name: "Гар хийц.",
    description:
      "Төмөр бэлдэцээс эхлээд будаг, монтаж, тоноглол зэрэг бүхийл деталь хэсгүүдийг гараар хийж гүйцэтгэдэг.",
    icon: ServerIcon,
  },
];

export default function Example() {
  return (
    <div className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-y-16 gap-x-8 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Найдвартай байдал
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9 text-left">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon
                        className="absolute top-1 left-1 h-5 w-5 text-indigo-600"
                        aria-hidden="true"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <div className="">
            <img
              src={Trust}
              alt="Product screenshot"
              className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
